import { useTranslation } from 'react-i18next';

export interface PaymentMethodData {
  [key: string]: {
    name: string;
    img: React.ReactNode;
    withBrandedLogo?: boolean;
    translationKey?: string;
    isRedirect?: boolean;
    visibilityRequirements?: string;
  };
}

export const APPLE_PAY_REQUIRED = 'APPLE_PAY_BROWSER_REQUIREMENT';
const BC_CDN = 'https://bccdn.britishcouncil.org/dev/online-payment-icons';
const PM_KEY = 'npp:paymentMethodChanger.paymentMethodsName';

export const PAYMENT_METHOD_DATA: PaymentMethodData = {
  card: {
    name: 'Card',
    img: <img src={`${BC_CDN}/v2/card_payment.svg`} alt="card" />,
    translationKey: `${PM_KEY}.card`,
  },
  banktransfer: {
    name: 'Bank Transfer',
    img: <img src={`${BC_CDN}/v2/bank_transfer.svg`} alt="Bank Transfer" />,
    translationKey: `${PM_KEY}.bankTransfer`,
  },
  paypal: {
    name: 'PayPal',
    img: <img src={`${BC_CDN}/v2/paypal.svg`} alt="PayPal" />,
    withBrandedLogo: true,
  },
  onlinebankingindia: {
    name: 'Online Banking India',
    img: <img src={`${BC_CDN}/v2/online_banking_india.svg`} alt="Online Banking" />,
    translationKey: `${PM_KEY}.onlineBankingIndia`,
    isRedirect: true,
  },
  walletsindia: {
    name: 'Wallets India',
    img: <img src={`${BC_CDN}/v2/mobile_payments.svg`} alt="Wallets" />,
    translationKey: `${PM_KEY}.walletsIndia`,
    isRedirect: true,
  },
  paytm: {
    name: 'PayTM',
    img: <img src={`${BC_CDN}/v2/paytm.svg`} alt="PayTM" />,
    withBrandedLogo: true,
    isRedirect: true,
  },
  upi: {
    name: 'UPI',
    img: <img src={`${BC_CDN}/v2/upi.svg`} alt="UPI" />,
    withBrandedLogo: true,
    isRedirect: true,
  },
  alipay: {
    name: 'Alipay',
    img: <img src={`${BC_CDN}/v2/alipay.svg`} alt="AliPay" />,
    withBrandedLogo: true,
  },
  wechatpay: {
    name: 'WeChat Pay',
    img: <img src={`${BC_CDN}/v2/wechatpay.svg`} alt="Wechatpay" />,
    withBrandedLogo: true,
  },
  przelewy24: {
    name: 'Przelewy24',
    img: <img src={`${BC_CDN}/v2/przelewy24.svg`} alt="Przelewy24" />,
    withBrandedLogo: true,
  },
  klarna: {
    name: 'Klarna',
    img: <img src={`${BC_CDN}/v2/klarna.svg`} alt="Klarna" />,
    withBrandedLogo: true,
  },
  paydollar: {
    name: 'Paydollar',
    img: <img src={`${BC_CDN}/card_and_online_bank_transfer.svg`} alt="Card or Online Payment" />,
    translationKey: `${PM_KEY}.paydollar`,
    isRedirect: true,
  },
  paydollarcard: {
    name: 'Paydollar Card',
    img: <img src={`${BC_CDN}/card_payment.svg`} alt="Card" />,
    translationKey: `${PM_KEY}.paydollarcard`,
    isRedirect: true,
  },
  paydollarvietnam: {
    name: 'Online payment',
    img: <img src={`${BC_CDN}/v2/online_banking_india.svg`} alt="Online payment" />,
    translationKey: `${PM_KEY}.paydollarvietnam`,
    isRedirect: true,
  },
  seerbitv2: {
    name: 'Seerbit',
    img: <img src={`${BC_CDN}/v2/seerbit.svg`} alt="Seerbit" />,
    withBrandedLogo: true,
  },
  mobilemoney: {
    img: <img src={`${BC_CDN}/v2/mobile_payments.svg`} alt="Mobile money" />,
    name: 'Mobile Money',
    translationKey: `${PM_KEY}.mobileMoney`,
  },
  fpx: {
    name: 'FPX',
    img: <img src={`${BC_CDN}/v2/FPX.svg`} alt="FPX" />,
    withBrandedLogo: true,
  },
  grabpay: {
    name: 'GrabPay',
    img: <img src={`${BC_CDN}/v2/grabpay.svg`} alt="Grabpay" />,
    withBrandedLogo: true,
    isRedirect: true,
  },
  esewa: {
    name: 'Esewa',
    img: <img src={`${BC_CDN}/v2/esewa.svg`} alt="eSewa" />,
    withBrandedLogo: true,
    isRedirect: true,
  },
  bancontact: {
    name: 'Bancontact',
    img: <img src={`${BC_CDN}/v2/bancontact.svg`} alt="Bancontact" />,
    withBrandedLogo: true,
  },
  blik: {
    name: 'Blik',
    img: <img src={`${BC_CDN}/v2/blik.svg`} alt="Blik" />,
    withBrandedLogo: true,
  },
  multibanco: {
    name: 'Multibanco',
    img: <img src={`${BC_CDN}/v2/multibanco.svg`} alt="Multibanco" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.multibanco`,
  },
  mobilebanking: {
    name: 'Mobile Banking',
    img: <img src={`${BC_CDN}/v2/mobile_banking.svg`} alt="Mobilebanking" />,
    translationKey: `${PM_KEY}.mobileBanking`,
  },
  netbanking: {
    name: 'Net Banking',
    img: <img src={`${BC_CDN}/v2/net_banking.svg`} alt="Netbanking" />,
    translationKey: `${PM_KEY}.netBanking`,
  },
  atmcard: {
    name: 'ATM Card',
    img: <img src={`${BC_CDN}/v2/card_payment.svg`} alt="Card" />,
    translationKey: `${PM_KEY}.atmCard`,
  },
  internationalcard: {
    name: 'International Card',
    img: <img src={`${BC_CDN}/v2/international_card.svg`} alt="Card" />,
    translationKey: `${PM_KEY}.internationalCard`,
  },
  qrcode: {
    name: 'QR Code',
    img: <img src={`${BC_CDN}/v2/qr_code.svg`} alt="QR" />,
    translationKey: `${PM_KEY}.qrCode`,
  },
  vietqr: {
    name: 'VietQR',
    img: <img src={`${BC_CDN}/v2/vietQR.svg`} alt="Alepay Viet QR" />,
    withBrandedLogo: true,
  },
  ideal: {
    name: 'iDeal',
    img: <img src={`${BC_CDN}/v2/ideal.svg`} alt="Ideal" />,
    withBrandedLogo: true,
    isRedirect: true,
  },
  upistripe: {
    name: 'UPI',
    img: <img src={`${BC_CDN}/v2/upi.svg`} alt="UPI" />,
    withBrandedLogo: true,
  },
  paybybank: {
    name: 'Pay by Bank',
    img: <img src={`${BC_CDN}/v2/pay_by_bank.svg`} alt="Pay By Bank" />,
    translationKey: `${PM_KEY}.payByBank`,
    isRedirect: true,
  },
  cybersource: {
    name: 'CyberSource',
    img: <img src={`${BC_CDN}/v2/cybersource.svg`} alt="Cybersource" />,
    withBrandedLogo: true,
  },
  pix: {
    name: 'Pix',
    img: <img src={`${BC_CDN}/v2/pix.svg`} alt="pix" />,
    withBrandedLogo: true,
  },
  promptpay: {
    name: 'PrompPay',
    img: <img src={`${BC_CDN}/v2/promptpay.svg`} alt="Promptpay" />,
    withBrandedLogo: true,
  },
  fiuubanktransfers: {
    name: 'FIUU Bank Transfers',
    img: <img src={`${BC_CDN}/v2/fiuu_bank_transfer.svg`} alt="Online Bank Transfer" />,
    translationKey: `${PM_KEY}.fiuuBankTransfers`,
  },
  syncbanktransfer: {
    name: 'Sync Bank Transfer',
    img: <img src={`${BC_CDN}/v2/sync_bank_transfer.svg`} alt="Online Bank Transfer" />,
    translationKey: `${PM_KEY}.syncBankTransfer`,
  },
  qris: {
    name: 'Qris',
    img: <img src={`${BC_CDN}/v2/qris.svg`} alt="Qris" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.qris`,
  },
  jenius: {
    name: 'Jenius',
    img: <img src={`${BC_CDN}/v2/jenius.svg`} alt="Jenius" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.jenius`,
  },
  virtualaccount: {
    name: 'Virtual Account',
    img: <img src={`${BC_CDN}/v2/virtual_accounts.svg`} alt="Virtual Account" />,
    translationKey: `${PM_KEY}.virtualAccount`,
  },
  ewallet: {
    name: 'e-Wallet',
    img: <img src={`${BC_CDN}/v2/mobile_payments.svg`} alt="e-Wallet" />,
    translationKey: `${PM_KEY}.ewallet`,
  },
  googlepay: {
    name: 'Google Pay',
    img: <img src={`${BC_CDN}/googlepay.svg`} alt="Google Pay" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.googlePay`,
  },
  applepay: {
    name: 'Apple Pay',
    img: <img src={`${BC_CDN}/applepay.svg`} alt="Apple Pay" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.applePay`,
    visibilityRequirements: APPLE_PAY_REQUIRED,
  },
  mobilemoneyghana: {
    name: 'Mobile Money Ghana',
    img: <img src={`${BC_CDN}/v2/mobile_payments.svg`} alt="Mobile Money Ghana" />,
    translationKey: `${PM_KEY}.mobileMoney`,
  },
  mpesa: {
    name: 'Mobile Money Kenya',
    img: <img src={`${BC_CDN}/v2/mobile_payments.svg`} alt="Mobile Money Kenya" />,
    translationKey: `${PM_KEY}.mobileMoney`,
  },
  mobilemoneyxof: {
    name: 'Mobile Money Senegal',
    img: <img src={`${BC_CDN}/v2/mobile_payments.svg`} alt="Mobile Money Senegal" />,
    translationKey: `${PM_KEY}.mobileMoney`,
  },
  nqr: {
    name: 'NQR',
    img: <img src={`${BC_CDN}/v2/nqrlogov2.svg`} alt="NQR payment method" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.nqr`,
  },
  ussd: {
    name: 'USSD',
    img: <img src={`${BC_CDN}/v2/mobile_banking.svg`} alt="USD payment method" />,
    translationKey: `${PM_KEY}.ussd`,
  },
  bankaccounts: {
    name: 'Bank Accounts',
    img: <img src={`${BC_CDN}/v2/fiuu_bank_transfer.svg`} alt="Bank Accounts" />,
    translationKey: `${PM_KEY}.bankAccounts`,
  },
  paystackcard: {
    name: 'Paystack Card',
    img: <img src={`${BC_CDN}/v2/card.svg`} alt="Paystack Card" />,
    translationKey: `${PM_KEY}.paystackCard`,
  },
  cardinstalmentmexico: {
    name: 'Credit or debit card',
    img: <img src={`${BC_CDN}/v2/card_payment.svg`} alt="Card" />,
    translationKey: `npp:decisionPage.providers.CARDINSTALMENTMEXICO.title`,
  },
  amazonpay: {
    name: 'Amazon Pay',
    img: <img src={`${BC_CDN}/v2/amazon_pay.png`} alt="Amazon Pay" />,
    withBrandedLogo: true,
    translationKey: `npp:decisionPage.providers.AMAZONPAY.title`,
  },
  paynow: {
    name: 'PayNow',
    img: <img src={`${BC_CDN}/v2/paynow.svg`} alt="PayNow" />,
    translationKey: `${PM_KEY}.paynow`,
    withBrandedLogo: true,
  },
  revolutpay: {
    name: 'Revolut',
    img: <img src={`${BC_CDN}/v2/revolut_logo.svg`} alt="Revolut Pay" />,
    withBrandedLogo: true,
    translationKey: `${PM_KEY}.revolutpay`,
    isRedirect: true,
  },
};

export const getPaymentMethodDataOrDefault = (shortCode: string): PaymentMethodData[string] => {
  const normalizedMethod = shortCode.toLowerCase();
  return (
    PAYMENT_METHOD_DATA[normalizedMethod] || {
      name: 'Online Payment',
      img: <img src={`${BC_CDN}/v2/card_payment.svg`} alt={shortCode} />,
    }
  );
};

const InternalPaymentMethodName = ({ shortCode }: { shortCode: string }): JSX.Element => {
  const { t } = useTranslation();
  const paymentMethod = PAYMENT_METHOD_DATA[shortCode.toLowerCase()] || {
    name: shortCode,
    translationKey: '',
  };

  return (
    <>
      {paymentMethod.translationKey
        ? t(paymentMethod.translationKey, paymentMethod.name)
        : paymentMethod.name}
    </>
  );
};

export const getInternalPaymentMethodName = (shortCode: string): React.ReactNode => {
  return <InternalPaymentMethodName shortCode={shortCode} />;
};
